import { actionTypes } from '../actions/transferWizard';

interface IBaseAction {
  type: string;
}

interface IAllPossiblePayloads {
  applicantType: number;
  location: number;
  notes: string;
  vendor: number;

  firstName: string; 
  middleName: string;
  lastName: string; 
  dob: Date;
  ssn4: string;
  phone: string;
  email: string;
  gender: string;
  race: string;
  height: string;
  weight: string;
  eye: string;
  hair: string;
  pob: string;
  citizenship: string;
  reason: string;
  residence: string;
};

type WizardAction = IBaseAction & Partial<IAllPossiblePayloads>;

export interface IWizardState {
  disclaimerAccepted?: boolean;

  applicantType?: number;
  location?: number;
  notes?: string;
  vendor?: number;

  firstName?: string;
  middleName?: string;
  lastName?: string;
  dob?: Date;
  ssn4?: string;
  phone?: string;
  email?: string;
  gender?: string;
  race?: string;
  height?: string;
  weight?: string;
  eye?: string;
  hair?: string;
  pob?: string;
  citizenship?: string;
  reason?: string;
  residence?: string;

  step?: number;
}

const reducer = (state: IWizardState = {}, action: WizardAction) => {
  switch (action.type) {
    case actionTypes.CLEAR:
      return {};
    case actionTypes.START:
      return {
        step: 1
      };
    case actionTypes.ACCEPT_DISCLAIMER:
      return {
        ...state,
        step: 2
      };
    case actionTypes.SELECT_TYPE:
      return {
        ...state,
        step: 3,
        applicantType: action.applicantType,
        location: action.location,
        notes: action.notes,
        vendor: action.vendor,
      };
    case actionTypes.SET_DATA:
      return {
        ...state,
        step: 4,
        firstName: action.firstName, 
        middleName: action.middleName,
        lastName: action.lastName, 
        dob: action.dob,
        ssn4: action.ssn4,
        phone: action.phone,
        email: action.email,
        gender: action.gender,
        race: action.race,
        height: action.height,
        weight: action.weight,
        eye: action.eye,
        hair: action.hair,
        pob: action.pob,
        citizenship: action.citizenship,
        reason: action.reason,
        residence: action.residence
      };
    case actionTypes.CONFIRMED:
      return {
        ...state,
        step: 5
      };
  }
  return state;
}

export default reducer;


